import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';
import { Route } from '@angular/router';

export const ContractRoutes: Route = {
    path: 'contracts',
    data: { title: 'contract' },
    children: [
        {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./contract/contract.component').then((m) => m.ContractComponent),
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'contract-inventory',
            loadComponent: () =>
                import('./contract-inventory/contract-inventory.component').then((m) => m.ContractInventoryComponent),
            data: { title: 'Contract inventory' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'contract-plantation',
            loadComponent: () =>
                import('./contract-plantation/contract-plantation.component').then(
                    (m) => m.ContractPlantationComponent
                ),
            data: { title: 'Contract plantation' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'contract-rotation',
            loadComponent: () =>
                import('./contract-rotation/contract-rotation.component').then((m) => m.ContractRotationComponent),
            data: { title: 'Contract rotation' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'contract-type',
            loadComponent: () => import('./contract-type/contract-type.component').then((m) => m.ContractTypeComponent),
            data: { title: 'Contract type' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'contract-user',
            loadComponent: () => import('./contract-user/contract-user.component').then((m) => m.ContractUserComponent),
            data: { title: 'Contract user' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'contract-season',
            loadComponent: () =>
                import('./contract-season/contract-season.component').then((m) => m.ContractSeasonComponent),
            data: { title: 'Contract season' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'contract-enterprises',
            loadComponent: () =>
                import('./contract-enterprises/contract-enterprises.component').then(
                    (m) => m.ContractEnterprisesComponent
                ),
            data: { title: 'Contract enterprises' },
            // canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
    ],
};
